/* (c) Copyright Frontify Ltd., all rights reserved. */

export const EMOJI_PLUGIN = 'emoji-plugin';
